import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=7fce6eda&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=ts&"
export * from "./BaseCard.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=7fce6eda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce6eda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
